module.exports = __webpack_public_path__ + "static/media/VC-Logo.5296207f.png";